import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/svgio/svgio/src/apps/website/src/app/(client-layout)/(public)/(nav-layout)/page.client.tsx");
